import axios from 'axios'
import authUser from './authUser'

const WPAPIPATH = '/wp-json/pmkino/v1'

const HTTPMethod = Object.freeze ({
    GET: 'GET',
	POST: 'POST',
	PUT: 'PUT',
	PATCH: 'PATCH',
    DELETE: 'DELETE'
})

const apiURL = Object.freeze ({
    WP_PAGES:                           WPAPIPATH + '/wp-pages',
    WP_SERVICEPAGES:                    WPAPIPATH + '/wp-service-pages',
    WP_MENUITEMS:                       WPAPIPATH + '/wp-menuitems',
    WP_DATA:                            WPAPIPATH + '/wp-data',
    PROGRAM_FETCH:                      WPAPIPATH + '/program-fetch',
    PROGRAM_GET:                        WPAPIPATH + '/program-get',
    PROGRAM_UPDATE:                     WPAPIPATH + '/program-update',
    PROGRAM_FILTER:                     WPAPIPATH + '/program-filter',
    PROGRAM_CREATE_ITEM:                WPAPIPATH + '/program-create',
    PRINT_DATA_GET:                     WPAPIPATH + '/print-get',
    PRINT_DATA_UPDATE:                  WPAPIPATH + '/print-update',
    PUSH_DATA_GET:                      WPAPIPATH + '/push-data',
    PUSH_CREATE:                        WPAPIPATH + '/push-create',    
    PUSH_DATA_UPDATE:                   WPAPIPATH + '/push-update',    
    GET_TOKEN:                          '/wp-json/jwt-auth/v1/token',
    VALIDATE_TOKEN:                     '/wp-json/jwt-auth/v1/token/validate',
    SESSION_GET:                        WPAPIPATH + '/wp-session-get',
    SESSION_RELAOD:                     WPAPIPATH + '/wp-session-reload',
    SESSION_REFRESH:                    WPAPIPATH + '/wp-session-refresh',
    SESSION_ALIVE:                      WPAPIPATH + '/wp-session-alive',
    SESSION_ALIVE_BYPASS:               WPAPIPATH + '/wp-session-alive-bypass',
    SESSION_DELETE:                     WPAPIPATH + '/wp-session-delete',
    LOGOUT:                             WPAPIPATH + '/wp-logout',
    MEDIAFILE:                          '/wp-json/wp/v2/media',
    MEDIAFILE_BY_URL:                   WPAPIPATH + '/wp-media-add-url',
    NEWSLETTER_GET_ALL_NEWSLETTERS:     WPAPIPATH + '/newsletter',
    NEWSLETTER_BASICS_UPDATE:           WPAPIPATH + '/newsletter/update',
    NEWSLETTER_STRUCTURE_CREATE:        WPAPIPATH + '/newsletter/structure/create',
    NEWSLETTER_STRUCTURE_UPDATE:        WPAPIPATH + '/newsletter/structure/update',
    NEWSLETTER_STRUCTURE_DELETE:        WPAPIPATH + '/newsletter/structure/delete',
    NEWSLETTER_CAMPAIGN_CREATE:         WPAPIPATH + '/newsletter/campaign/create',
    NEWSLETTER_CAMPAIGN_UPDATE:         WPAPIPATH + '/newsletter/campaign/update',
    NEWSLETTER_CAMPAIGN_SEND:           WPAPIPATH + '/newsletter/campaign/send',
    NEWSLETTER_LOCAL_DATA_GET:          WPAPIPATH + '/newsletter-local-get',
    NEWSLETTER_LOCAL_DATA_UPDATE:       WPAPIPATH + '/newsletter-local-update',
    MULTISITE_SELECTOR_GET:             WPAPIPATH + '/multisite-selector-get',
    MULTISITE_SELECTOR_UPDATE:          WPAPIPATH + '/multisite-selector-update',
    ROUTES_DATA_GET:                    WPAPIPATH + '/routes-get',
    CLI_DATA_GET:                       WPAPIPATH + '/cli-data-get',
    EVENT_DATA_GET_ALL:                 WPAPIPATH + '/events-data-all-get',
    EVENT_DATA_EVENT_UPDATE:            WPAPIPATH + '/events-data-event-update',
    EVENT_DATA_EVENT_DELETE:            WPAPIPATH + '/events-data-event-delete',
    EVENT_DATA_SEND_MAIL:               WPAPIPATH + '/events-data-send-mail',
})

const createHeader = params  => (
    Object.freeze ({
        ...params.token     && {'Authorization' : `Bearer ${params.token}` },
        ...params.multipart && {'Content-Type'  : 'multipart/form-data' },
        ...params.nonce     && {'X-WP-Nonce': params.nonce},
        'Pmclient-Session': authUser.getSessionToken()
    })
)

const createApiCallConfig = params => (
    Object.freeze ({
        ...params.baseURL       && { baseURL: params.baseURL + apiURL[params.apiEndpoint] },
        //...params.apiEndpoint   && { url: apiURL[params.apiEndpoint] },
        ...params.url           && { url: params.url},
        ...params.method        && { method: HTTPMethod[params.method] },
        ...params.params        && { params: params.params },
        ...params.data          && { data: params.data },
        ...params.headerParams  && { headers: createHeader(params.headerParams) },
        ...params.signal        && { signal: params.signal }
    })
)

const createApiCall = params => axios(createApiCallConfig(params))



// const createApiCall = params => (
//     axios(createApiCallConfig(params))
//     //
//     // ToDo: Media Endpoints testen und herasufinden was das auskommentierte unten soll!!!
//     //
//     // .then(response => {
//     //     return response
//     // })
//     // .catch(error => {
//     //     if (error.response) {
//     //         //return Promise.reject('The request was made but the server responded with a status code that fails out of the range of 2xx')
//     //         return Promise.reject('Upload wurde abgelehnt.')
//     //     } else if (error.request) {
//     //         return Promise.reject('The request was made but no response was received')
//     //     } else {
//     //         return Promise.reject('Something happened in setting up the request that triggered an Error')
//     //     }
//     // })
// )

export default createApiCall